import i18n from "../../i18n";

export const UserProfileAssessmentPriority = {
    Low: i18n.t('userProfile.assessments.low'),
    Moderate: i18n.t('userProfile.assessments.moderate'),
    High: i18n.t('userProfile.assessments.high'),
}